import { render, staticRenderFns } from "./upRenew.vue?vue&type=template&id=5b342c67&scoped=true&"
import script from "./upRenew.vue?vue&type=script&lang=js&"
export * from "./upRenew.vue?vue&type=script&lang=js&"
import style0 from "./upRenew.vue?vue&type=style&index=0&id=5b342c67&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b342c67",
  null
  
)

export default component.exports